export default __webpack_public_path__ + "static/media/pic11.47b17c0a.jpg";